import React, { useEffect, useState } from "react";
import { WifiSlash, CloudArrowDown } from "@phosphor-icons/react";

/**
 * Shows a small banner when the browser goes offline.
 * Combined with the service worker's cache, the app stays usable in read-mode.
 */
export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const up = () => setOffline(false);
    const down = () => setOffline(true);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);
  if (!offline) return null;
  return (
    <div
      data-testid="offline-banner"
      className="fixed top-0 inset-x-0 z-[60] bg-amber-500/90 text-black text-xs font-medium px-3 py-1.5 flex items-center justify-center gap-2 shadow"
    >
      <WifiSlash size={13} weight="bold" />
      You're offline — showing cached data <CloudArrowDown size={13} weight="duotone" />
    </div>
  );
}
